import type { FunctionComponent } from 'react'

export const YoutubePlayButton: FunctionComponent = () => (
  <div
    className="cursor-pointer"
    style={{
      boxSizing: 'border-box',
      borderColor: 'transparent transparent transparent #fff',
      borderStyle: 'solid',
      borderWidth: '1em 0 1em 1.5em',
    }}
  />
)
